import { Outlet, NavLink, useLocation } from "react-router-dom";
import { BG, FONT, ROOMS } from "@/lib/yuoDesign";
import { useResponsive } from "@/lib/responsive";
import MobileDock from "@/components/mobile/MobileDock";
import StoneOrb from "@/components/yuo/StoneOrb";

const TABS = [
  { to: "/mirror",    label: "Mirror",    room: "mirror",    testId: "tab-mirror" },
  { to: "/diary",     label: "Diary",     room: "diary",     testId: "tab-diary" },
  { to: "/library",   label: "Library",   room: "library",   testId: "tab-library" },
  { to: "/content",   label: "Creator",   room: "content",   testId: "tab-content" },
  { to: "/symbiosis", label: "Symbiosis", room: "symbiosis", testId: "tab-symbiosis" },
];

const NAV_HEIGHT = 74;
const DOCK_HEIGHT = 86;

export default function TabsLayout() {
  const location = useLocation();
  const { isPhone } = useResponsive();
  if (isPhone) {
    return (
      <div style={{ position: "fixed", inset: 0, background: BG, display: "flex", flexDirection: "column" }}>
        <div style={{
          flex: 1, overflow: "hidden", display: "flex", flexDirection: "column",
          paddingTop: "env(safe-area-inset-top, 0px)",
          paddingBottom: `calc(${DOCK_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
        }}>
          <Outlet />
        </div>
        <MobileDock />
      </div>
    );
  }
  return (
    <div style={{
      position: "fixed", inset: 0, background: BG,
      display: "flex", flexDirection: "column",
    }}>
      <div style={{
        flex: 1, overflow: "hidden",
        display: "flex", flexDirection: "column",
        paddingBottom: `calc(${NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
      }}>
        <Outlet />
      </div>

      <nav data-testid="bottom-nav" style={{
        position: "fixed", left: 0, right: 0, bottom: 0,
        background: "var(--yuo-nav-bg)", height: NAV_HEIGHT,
        boxShadow: "0 -1px 0 var(--yuo-nav-line)",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        display: "flex", zIndex: 50,
      }}>
        {TABS.map((t) => {
          const active = location.pathname.startsWith(t.to);
          const meta = ROOMS[t.room];
          return (
            <div key={t.to} style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <NavLink
                to={t.to} data-testid={t.testId}
                style={{
                  display: "inline-flex", flexDirection: "column",
                  alignItems: "center", justifyContent: "center",
                  gap: 6, textDecoration: "none",
                  color: active ? "var(--yuo-nav-active)" : "var(--yuo-nav-inactive)",
                  fontFamily: FONT, fontSize: 8.5,
                  letterSpacing: "0.2em", textTransform: "uppercase",
                  padding: "6px 4px",
                  outline: "none",
                  border: "none",
                  background: "transparent",
                  boxShadow: "none",
                  borderRadius: 999,
                  minWidth: 44,
                  WebkitTapHighlightColor: "transparent",
                  WebkitAppearance: "none",
                  appearance: "none",
                }}
                onFocus={(e) => { e.currentTarget.style.outline = "none"; e.currentTarget.style.boxShadow = "none"; }}>
                <StoneOrb
                  color={t.room}
                  size={active ? 22 : 16}
                  style={{
                    borderRadius: "50%",
                    overflow: "hidden",
                    boxShadow: active
                      ? `0 0 26px rgba(${meta.rgb},0.65)`
                      : `0 0 12px rgba(${meta.rgb},0.25)`,
                  }}
                />
                <span>{t.label}</span>
              </NavLink>
            </div>
          );
        })}
      </nav>
    </div>
  );
}
